import * as React from 'react';
const h = React.createElement;

export interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = function Checkbox(props) {
  const { checked, onChange, disabled, children, className = '' } = props;
  return h(
    'label',
    {
      className: `inline-flex items-center gap-2 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`,
    },
    h('input', {
      type: 'checkbox',
      checked,
      disabled,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) onChange(e.target.checked);
      },
      className: 'rounded border-dark-600 bg-dark-800 text-primary-600 focus:ring-primary-500',
    }),
    children && h('span', { className: 'text-sm text-dark-200' }, children),
  );
};

export { Checkbox };
